import { TradingOfferOperation } from 'types';
import { getPartyId } from './getPartnerId';

export const getOperationType = (
  operation: TradingOfferOperation,
  currentPartnerId: string
): 'BUY' | 'SELL' => {
  const buyerId = getPartyId(operation.buyer);
  return buyerId === currentPartnerId ? 'BUY' : 'SELL';
};
